module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ca":{"espectacle":"Espectacle","companyia":"companyia","agenda":"agenda","contacte":"contacte"},"es":{"espectacle":"Espectaculo","companyia":"compañia","agenda":"agenda","contacte":"contacto"},"en":{"espectacle":"SHOW","companyia":"COMPANY","agenda":"AGENDA","contacte":"CONTACT"},"fr":{"espectacle":"SPECTACLE","companyia":"COMPAGNIE","agenda":"AGENDA","contacte":"CONTACT"}}')
  delete Component.options._Ctor
}
